// modal/detail/constants.js
export const TONES = {
  teal: { bg: 'rgba(0,150,136,.14)', fg: '#009688', bd: 'rgba(0,150,136,.24)' },
  violet: { bg: 'rgba(124,58,237,.14)', fg: '#7c3aed', bd: 'rgba(124,58,237,.22)' },
  amber: { bg: 'rgba(255,122,0,.14)', fg: '#ff7a00', bd: 'rgba(255,122,0,.22)' },
  blue: { bg: 'rgba(33,150,243,.14)', fg: '#2196f3', bd: 'rgba(33,150,243,.22)' },
};
